import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../components/AuthContext/AuthContext";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";

const CallbackPage = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get("token");

      if (!authContext) {
        return;
      }

      if (token) {
        authContext.setToken(token);
        authContext.setIsAuthenticated(true);
        localStorage.setItem("authToken", token);
        navigate("/");
      } else {
        try {
          const response = await axios.post(
            `${API_BASE_URL}/auth/token`,
            {},
            { withCredentials: true }
          );

          const newToken = response.data.token;

          if (newToken) {
            authContext.setToken(newToken);
            authContext.setIsAuthenticated(true);
            localStorage.setItem("authToken", newToken);
            navigate("/");
          } else {
            navigate("/");
          }
        } catch (error) {
          navigate("/");
        }
      }
    };

    handleCallback();
  }, [authContext, navigate, location]);

  return <div>Processing login...</div>;
};

export default CallbackPage;
